import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService, HttpBaseService, LocalizationService, NotifyService } from '@app/core';
import { ApiControllerEnum } from '@app/shared/common/enums';
import { SchedulingEventListItem } from '../models/scheduling-event/scheduling-event-list-item';
import { SchedulingEventForm } from '../models/scheduling-event/scheduling-event-form-item';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SchedulingEventService extends HttpBaseService{

  constructor(private http: HttpClient
    , private notifyServ: NotifyService
    , private localizationService: LocalizationService
    , private configService: ConfigurationService) {
    super(http, ApiControllerEnum.SchedulingEvent, notifyServ, localizationService, configService);
  }

  getListByFilter(filter: any): Observable<SchedulingEventListItem[]> {
    return this.post("GetListByFilter", filter, true);
  }

  save(obj: SchedulingEventForm): Observable<any> {
      return this.post("SaveAsync", obj, true);
  }
}